import { createContext, useContext } from "react";

import { useCorpGlobalSearchListController } from "./index";

interface ControllerContextProviderProps {
  children: React.ReactNode;
}

type TControllerContextValue = ReturnType<
  typeof useCorpGlobalSearchListController
>;

const ControllerContext = createContext<TControllerContextValue>(
  {} as TControllerContextValue
);

const CorpGlobalSearchListControllerContextProvider = ({
  children,
}: ControllerContextProviderProps) => {
  const props = useCorpGlobalSearchListController();

  return (
    <ControllerContext.Provider value={props}>
      {children}
    </ControllerContext.Provider>
  );
};

export const useCorpGlobalSearchListControllerContext = () =>
  useContext(ControllerContext);
export default CorpGlobalSearchListControllerContextProvider;
